// extracted by mini-css-extract-plugin
export default {"control":"LanguagePicker_control__rAlCZ","label":"LanguagePicker_label__dSWnT","icon":"LanguagePicker_icon__DAWXX"};